import React, { useState } from "react";
import { useI18n } from "../context/I18nContext";
import { Crosshair } from "lucide-react";
import { getFaceConfig } from "./TargetFace";

export default function TargetConfigModal({ initial, onConfirm }) {
  const { t } = useI18n();
  const initType = ["full", "trispot_recurve", "trispot_compound"].includes(initial?.faceType)
    ? initial.faceType : "full";
  const [faceType, setFaceType] = useState(initType);

  const FACES = [
    { value: "full", label: t("targetcfg.full") },
    { value: "trispot_recurve", label: t("targetcfg.trispot_recurve") },
    { value: "trispot_compound", label: t("targetcfg.trispot_compound") },
  ];

  const btn = (active) =>
    "w-full py-3 rounded-md font-bold uppercase tracking-wide text-sm transition-colors " +
    (active ? "bg-cyan-400 text-black" : "bg-zinc-950 border border-zinc-800 text-zinc-400 hover:border-zinc-600 hover:text-white");

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 60, background: "var(--bl-overlay)", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
      <div className="w-full max-w-sm glass-panel rounded-2xl p-6 space-y-5">
        <div className="flex items-center gap-2">
          <Crosshair className="h-5 w-5 text-cyan-400" />
          <h2 className="font-heading font-black text-xl uppercase tracking-tight">{t("targetcfg.title")}</h2>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-400 mb-2">{t("targetcfg.face")}</div>
          <div className="flex flex-col gap-2">
            {FACES.map((f) => (
              <button key={f.value} onClick={() => setFaceType(f.value)} className={btn(faceType === f.value)}>{f.label}</button>
            ))}
          </div>
        </div>

        <button onClick={() => onConfirm(getFaceConfig(faceType))}
          className="w-full bg-cyan-400 text-black hover:bg-cyan-300 font-bold uppercase tracking-wide px-6 py-3 rounded-md">
          {t("targetcfg.confirm")}
        </button>
      </div>
    </div>
  );
}
